import type { InboundConnectionState } from '@/lib/integrations/inbound/event-checklist'

/**
 * The tab a visit opens on. Post-connect-rich providers open on Manage; Slack,
 * and an inbound connection still waiting for its first signed event, open on
 * Setup, where their steps live; everything else on Overview.
 */
export function resolveDefaultTab(args: {
  isManageTabVisible: boolean
  isSetupFirst: boolean
}): string {
  if (args.isManageTabVisible) {
    return 'manage'
  }
  return args.isSetupFirst ? 'setup' : 'overview'
}

/**
 * The tab to render: the selected one (the user's pick, or Setup pinned while
 * a connection waits for its first event) while that tab still exists,
 * otherwise the default. A chosen Manage tab disappears after a disconnect, and an
 * unknown value would render no panel at all.
 */
export function resolveIntegrationTab(args: {
  selectedTab: string | null
  tabValues: ReadonlyArray<string>
  isManageTabVisible: boolean
  isSetupFirst: boolean
}): string {
  const { selectedTab, tabValues, ...defaults } = args
  if (selectedTab !== null && tabValues.includes(selectedTab)) {
    return selectedTab
  }
  return resolveDefaultTab(defaults)
}

/** Where an inbound provider's Setup event list stands. */
export function inboundConnectionState({
  isConnected,
  isPendingVerification,
}: {
  isConnected: boolean
  isPendingVerification: boolean
}): InboundConnectionState {
  if (isConnected) {
    return 'active'
  }
  return isPendingVerification ? 'pending' : 'none'
}
